<template>
  <div class="imageDetail">
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      class="dialog-class-image"
      :modal="false"
      custom-class="custom-class-image"
      :show-close="false"
    >
      <div style="width: 100%" v-if="imageis" @click="handleClose">
        <img style="width: 100%" :src="url" alt="" srcset="" />
      </div>
      <div style="height: 100%" v-else  @click="handleClose">
        <easy-player
          id="playerStr"
          :video-url="url"
          :live="false"
          :loop="true"
          class="easyplayer"
        ></easy-player>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: "",
    },
    imageis: {
      type: Boolean,
      default: true,
    },
  },
  data(){
    return{
      timenumber:0,
    }
  },
  methods: {
    handleClose() {
      // this.timenumber++;
      // let that = this;
      // setTimeout(function() {
      //   console.log(that.timenumber);
      //   that.timenumber = 0 ;
      // },500)
      // if(this.timenumber>=2){
      //   this.$emit("handleClose", false);
      //   this.timenumber = 0 ;
      // }
      this.$emit("handleClose", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.imageDetail {
  -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -khtml-user-select: none;
    user-select: none;
  .dialog-class-image {
    z-index: 10001 !important;
  }
  ::v-deep .v-modal {
    z-index: 10000 !important;
  }
  ::v-deep .custom-class-image {
    padding: 0px !important;
    background: none !important;
    width: 1400px !important;
    margin-left: -200px !important;
  }
}
</style>
